/**
 * Enum for TransactionAttributeUsage
 */
export var TxAttrUsage;
(function (TxAttrUsage) {
    TxAttrUsage[TxAttrUsage["Url"] = 129] = "Url";
})(TxAttrUsage || (TxAttrUsage = {}));
export default TxAttrUsage;
//# sourceMappingURL=txAttrUsage.js.map